// Recorder feature constants — extracted from RecorderPage.jsx so the
// commercial limits and hard caps live in one place.

export const FREE_RECORDING_LIMIT = 3;
export const FREE_SESSION_LIMIT = 3;
export const FREE_TRACK_LIMIT = 2;
export const MAX_TRACKS = 5;
